import { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Fade,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { toast } from "react-toastify";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

const ApplyNowModal = ({ open, onClose, selectedJob }) => {
  const [positionType, setPositionType] = useState(
    selectedJob || "General Application"
  );
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [experience, setExperience] = useState("");
  const [portfolio, setPortfolio] = useState("");
  const [linkedin, setLinkedin] = useState("");
  const [cvFile, setCvFile] = useState(null);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
  const [success, setSuccess] = useState(false);

  const jobOptions = [
    "General Application",
    "Fabricator",
    "Welder",
    "Design Engineer",
    "Quality Inspector",
    "Project Manager",
    "Production Supervisor",
    "Material Handler",
    "Admin / HR",
  ];

  // Upload Handler
  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.type !== "application/pdf") {
      alert("Only PDF Allowed");
      return;
    }
    setCvFile(file);
    setPdfPreviewUrl(URL.createObjectURL(file));
  };


  const handleSubmit = async () => {
    if (
      !fullName ||
      !email ||
      !phone ||
      !experience ||
      // !cvFile ||
      !positionType
    ) {
      toast.error("Please fill all required fields.");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("access_key", "de439868-536f-48aa-8379-c6d5b7602433");
      formData.append("Position Type", positionType);
      formData.append("Full Name", fullName);
      formData.append("Email", email);
      formData.append("Phone", phone);
      formData.append("Experience", experience);
      formData.append("LinkedIn", linkedin || "Not Provided");
      formData.append("Portfolio", portfolio || "Not Provided");
      // formData.append("CV", cvFile);
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (data.success) {
        setSuccess(true);
        setTimeout(() => {
          setSuccess(false);
          onClose();
          setPositionType("General Application");
          setFullName("");
          setEmail("");
          setPhone("");
          setExperience("");
          setPortfolio("");
          setLinkedin("");
          setCvFile(null);
          setPdfPreviewUrl(null);
        }, 1800);
      } else {
        toast.error("Submission failed: " + data.message);
      }
    } catch (err) {
      toast.error("Network error. Try again later.");
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!fullName || !email || !phone || !experience || !positionType) {
  //     toast.error("Please fill all required fields.");
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("form-name", "apply-now");
  //   formData.append("Position Type", positionType);
  //   formData.append("Full Name", fullName);
  //   formData.append("Email", email);
  //   formData.append("Phone", phone);
  //   formData.append("Experience", experience);
  //   formData.append("LinkedIn", linkedin || "Not Provided");
  //   formData.append("Portfolio", portfolio || "Not Provided");
  //   if (cvFile) formData.append("CV", cvFile);

  //   try {
  //     const res = await fetch("/", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //       body: encodeFormData(formData),
  //     });

  //     if (res.ok) {
  //       setSuccess(true);
  //       toast.success("Application submitted successfully!");
  //       setTimeout(() => {
  //         setSuccess(false);
  //         onClose();
  //         resetForm();
  //       }, 1800);
  //     } else {
  //       toast.error("Submission failed. Please try again.");
  //     }
  //   } catch (err) {
  //     toast.error("Network error. Please try again later.");
  //   }
  // };

  // const resetForm = () => {
  //   setPositionType("General Application");
  //   setFullName("");
  //   setEmail("");
  //   setPhone("");
  //   setExperience("");
  //   setPortfolio("");
  //   setLinkedin("");
  //   setCvFile(null);
  //   setPdfPreviewUrl(null);
  // };

  // // Helper for Netlify form submission
  // const encodeFormData = (data) => {
  //   const formBody = [];
  //   for (const [key, value] of data.entries()) {
  //     formBody.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
  //   }
  //   return formBody.join("&");
  // };

  return (
    <Modal open={open} onClose={onClose}>
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "#fff",
            p: { xs: 3, sm: 5 },
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          {/* Closing Button */}
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", top: 16, right: 16, zIndex: 10 }}
          >
            <CloseIcon sx={{ fontSize: 32 }} />
          </IconButton>

          {/* SUCCESS SCREEN */}
          {success ? (
            <Box
              sx={{
                mt: 12,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <CheckCircleIcon sx={{ fontSize: 90, color: brandBlue }} />
              <Typography variant="h4" fontWeight={700} mt={2}>
                Application Sent!
              </Typography>
              <Typography mt={1} fontSize={18} color="gray">
                Thank you! Our HR team will reach out soon.
              </Typography>
            </Box>
          ) : (
            <>
              {/* HEADING */}
              <Typography
                variant="h4"
                fontWeight={900}
                textAlign="center"
                sx={{ mt: 6, color: brandBlue }}
              >
                Apply Now
              </Typography>

              {/* SUB HEADING selected JOB */}
              {/* <Typography
                textAlign="center"
                sx={{ mt: 1, fontSize: 18, color: brandRed, fontWeight: 600 }}
              >
                {selectedJob || "General Application"}
              </Typography> */}

              {/* FORM */}
              <Box
                sx={{
                  mt: 5,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2.8,
                  maxWidth: "650px",
                  mx: "auto",
                  width: "100%",
                }}
              >
                {/* Position Type */}
                <TextField
                  select
                  label="Position Type"
                  value={positionType}
                  onChange={(e) => setPositionType(e.target.value)}
                  fullWidth
                >
                  {jobOptions.map((job, i) => (
                    <MenuItem key={i} value={job}>
                      {job}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  label="Full Name"
                  fullWidth
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />

                <TextField
                  label="Email Address"
                  type="email"
                  fullWidth
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />

                <TextField
                  label="Phone Number"
                  type="tel"
                  fullWidth
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />

                <TextField
                  label="Experience (Years)"
                  type="number"
                  fullWidth
                  value={experience}
                  onChange={(e) => setExperience(e.target.value)}
                />

                {/* LinkedIn */}
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <TextField
                    label="LinkedIn Profile (Optional)"
                    fullWidth
                    value={linkedin}
                    onChange={(e) => setLinkedin(e.target.value)}
                  />
                  {/* <Button
                    variant="outlined"
                    sx={{ borderRadius: 2 }}
                    onClick={handleLinkedInAutofill}
                  >
                    Autofill from LinkedIn
                  </Button> */}
                </Box>

                {/* Portfolio */}
                <TextField
                  label="Portfolio / Website Link (Optional)"
                  fullWidth
                  value={portfolio}
                  onChange={(e) => setPortfolio(e.target.value)}
                />

                {/* Upload CV */}
                {/* <Button
                  component="label"
                  fullWidth
                  sx={{
                    py: 3,
                    borderRadius: 3,
                    border: "2px dashed #ccc",
                    bgcolor: "#fafafa",
                    "&:hover": { bgcolor: "#f0f0f0" },
                    textTransform: "none",
                    fontSize: 18,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                  }}
                >
                  {cvFile ? (
                    <>
                      <strong>{cvFile.name}</strong>
                      <span style={{ color: brandBlue }}>Change File</span>
                    </>
                  ) : (
                    <>
                      <strong>Upload CV (PDF Only)</strong>
                      <span style={{ color: "#777" }}>
                        Click to browse file
                      </span>
                    </>
                  )}

                  <input
                    type="file"
                    hidden
                    accept="application/pdf"
                    onChange={handleFileUpload}
                  />
                </Button> */}

                {/* PDF Preview */}
                {pdfPreviewUrl && (
                  <Box
                    sx={{
                      mt: 2,
                      height: 300,
                      borderRadius: 2,
                      border: "1px solid #ccc",
                      overflow: "hidden",
                    }}
                  >
                    <iframe
                      src={pdfPreviewUrl}
                      width="100%"
                      height="100%"
                      style={{ border: "none" }}
                    />
                  </Box>
                )}

                {/* SUBMIT */}
                <Button
                  fullWidth
                  variant="contained"
                  sx={{
                    py: 1.8,
                    fontSize: 18,
                    bgcolor: brandRed,
                    "&:hover": { bgcolor: "#b40000" },
                  }}
                  onClick={handleSubmit}
                >
                  Submit Application
                </Button>
              </Box>
            </>
          )}
        </Box>
      </Fade>
    </Modal>
  );
};

export default ApplyNowModal;
